import React from 'react';
import {FormSubscriberProps} from '../../@types/components/Form';
import {IEmptyModel} from '../../@interfaces/IEmptyModel';

export default function FormSubscriber<
        Model extends IEmptyModel = IEmptyModel
>(props: FormSubscriberProps<Model>) {
    return <>{props.children}</>;
}
